import React from 'react'

export default function FormItem(props) {
  return (
    <div style={{ marginBottom: 15, ...props.styles }} className={props.className}>
      {props.children}
    </div>
  )
}
